import { render, staticRenderFns } from "./VsmBackLinkButton.vue?vue&type=template&id=77b459ae&"
import script from "./VsmBackLinkButton.vue?vue&type=script&lang=js&"
export * from "./VsmBackLinkButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports